

export default {
  data() {
    return {
      password: '',
      showPassword: false,
      loading: false,
      hasError: false,
      isTouched: false,
    };
  },

  computed: {
    passwordHint() {
      if (!this.password.length && this.isTouched) {
        return 'Password field cannot be empty. Please input password.'
      }

      return this.hasError ? 'The password you entered is incorrect. Please try again.' : ''
    }
  },

  methods: {
    onShowPassword() {
      this.showPassword = !this.showPassword;

      this.$nextTick(() => {
        this.$refs.password.focus();
      })
    },

    onPasswordChange() {
      this.isTouched = true;
      this.hasError = !this.password.length;
    },

    async onAccessPage() {
      this.isTouched = true;

      if (!this.password.length) {
        this.hasError = true;
      }

      if (this.loading || this.hasError) {
        if (this.hasError) {
          this.$refs.password.focus();
        }

        return;
      }

      this.loading = true;
      const isSuccess = await this.$chatbotService.fetchInitialAmp(this.password);
      this.loading = false;
      this.hasError = !isSuccess;

      if (this.hasError) {
        this.$refs.password.focus();
      }
    }
  },
};
